import { API_BASE } from './api';

const BASE_URL = `${API_BASE}/progress-tracking`;

export async function fetchProgressDashboard(year, month) {
  const query = new URLSearchParams();

  if (year) query.append('year', year);
  if (month) query.append('month', month);

  const queryString = query.toString();
  const url = `${BASE_URL}/dashboard${queryString ? `?${queryString}` : ''}`;

  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || 'Failed to load progress tracking dashboard.');
  }

  return data;
}

export async function markTodaySmokeFree(note = '') {
  const url = `${BASE_URL}/mark-today`;

  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ note }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || 'Failed to record progress.');
  }

  return data;
}
